import { jsxs as c, jsx as l } from "react/jsx-runtime";
import { E as g, S as _ } from "./icons.types-0722eef5.js";
function v({ title: t, titleId: h, size: i, width: n, height: o, extended: r = !1, ...s }) {
  const e = r ? g : _, d = i ? e[i] : n || e[r ? "s" : "l"], a = i ? e[i] : o || e[r ? "s" : "l"];
  return /* @__PURE__ */ c(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 72 72",
      width: d,
      height: a,
      "aria-labelledby": h,
      ...s,
      children: [
        t ? /* @__PURE__ */ l("title", { id: h, children: t }) : null,
        /* @__PURE__ */ l("g", { clipPath: "url(#Caret-Right__Filled_svg__a)", children: /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            fillRule: "evenodd",
            d: "M36 1.5c19.054 0 34.5 15.446 34.5 34.5 0 19.054-15.446 34.5-34.5 34.5C16.946 70.5 1.5 55.054 1.5 36 1.5 16.946 16.946 1.5 36 1.5Zm-5.576 14.2-6.098 6.1 14.2 14.2-14.2 14.2 6.098 6.1 20.3-20.3-20.3-20.3Z",
            clipRule: "evenodd"
          }
        ) }),
        /* @__PURE__ */ l("defs", { children: /* @__PURE__ */ l("clipPath", { id: "Caret-Right__Filled_svg__a", children: /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M0 0h72v72H0z"
          }
        ) }) })
      ]
    }
  );
}
export {
  v as CaretRightFilled
};
